import React, {useState, useEffect} from 'react'
import {tre} from './trebus'

export const AppContext = React.createContext();

export function AppProvider({children}) {

    const [version] = useState(tre.version);
    const [user, setUser] = useState()

    // In local storage
    const [idCompany, setIdCompany] = useState();
    const [token, setToken] = useState(localStorage.getItem('token'));

    /**
     * Token changes
     */
    useEffect(() => {

        // Load user with the token
        if (token) {

            console.log('Loading user with token: ' + token)

            tre.api('GET', '/me', {
                context: {
                    user: {
                        api_token: token
                    }
                },
                success: (r) => {
                    setUser(r)
                },
                error: () => {
                    // Invalid or expired token - clear it silently
                    localStorage.removeItem('token');
                    setToken(null);
                }
            });
        }

    }, [token])

    /**
     * User changes
     */
    useEffect(() => {

        if (user) {

            if (user.id && user.api_token) {
                setToken(user.api_token)
                setIdCompany(user.company_id)
                localStorage.setItem('token', user.api_token);
                localStorage.setItem('idCompany', user.company_id);
            } else {
                setToken(null)
                setIdCompany(null)
                localStorage.clear()
            }
        }

    }, [user]);

    return (
        <AppContext.Provider
            value={{
                version: version,
                user: user,
                idCompany: idCompany,
                setUser: setUser,
            }}>

            {children}

        </AppContext.Provider>
    );
}

export const AppConsumer = AppContext.Consumer;
